import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {Timer} from './Timer';
import {Signup, isFilled, checkEmail} from "../../../Assets/Js/DateyardSignup";
import {waitingOverlay} from "../../../Assets/Js/WaitingOverlay";

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const stepButtons = document.querySelectorAll('.step-btn');
	const surveys = document.querySelectorAll('.survey');
	const wrapper = helper.$('#wrapper');
	const age = parseInt(helper.getData(wrapper, 'age'));
	const email = document.querySelector('#email') as HTMLInputElement;
	const birthday = document.querySelector('#birthday') as HTMLInputElement;
	const agbCheck = document.querySelector('#agbcheck') as HTMLInputElement
	const emailWarning = document.querySelector('#emailWarning') as HTMLDivElement;
	const agbWarning = document.querySelector('#agbWarning') as HTMLDivElement
	const targetUrl = helper.getData(wrapper, 'target');
	const failUrl = helper.getData(wrapper, 'fail');

	let signupRunning = false;

	let index = 0;

	let nextStep = async () => {
		helper.addClass(emailWarning, 'd-none');
		helper.addClass(agbWarning, 'd-none');

		if (index < surveys.length - 1) {
			await helper.fadeOut(surveys[index]);
			helper.addClass(surveys[index], 'd-none');
			index++;

			helper.removeClass(surveys[index], 'd-none');
			await helper.fadeIn(surveys[index]);

			if (index === 5) {
				setTimeout(nextStep, 1500);
			}
		} else {
			if (!checkEmail(email.value)) {
				helper.removeClass(emailWarning, 'd-none');
				return;
			}

			if (!agbCheck.checked) {
				helper.removeClass(agbWarning, 'd-none');
				return;
			}

			if (!signupRunning) {
				signupRunning = true;
				const gender = (document.querySelector('input[name="gender"]:checked') as HTMLInputElement).value;
				waitingOverlay();
				await Signup(targetUrl, failUrl, email.value, age, gender, birthday.value);
			}
		}
	};

	stepButtons.forEach((item) => {
		helper.addClickListener(item, (e) => {
			e.preventDefault();
			nextStep();
		})
	})

	Timer();
})
